import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { BrandProvider } from "./contexts/BrandContext";
import { Toaster } from "sonner";
import { IntroSplash } from "./components/IntroSplash";

import PlatformLogin from "./pages/platform/PlatformLogin";
import PlatformLayout from "./pages/platform/PlatformLayout";
import PlatformChangePassword from "./pages/platform/PlatformChangePassword";
import PlatformProfile from "./pages/platform/PlatformProfile";
import PlatformAudit from "./pages/platform/PlatformAudit";
import PlatformIdentity from "./pages/platform/PlatformIdentity";
import PlatformVerifyEmail from "./pages/platform/PlatformVerifyEmail";
import PlatformForgotPassword from "./pages/platform/PlatformForgotPassword";
import PlatformResetPassword from "./pages/platform/PlatformResetPassword";
import SalonCentral from "./pages/platform/SalonCentral";
import CrmVenditori from "./pages/platform/CrmVenditori";
import CrmContatti from "./pages/platform/CrmContatti";
import CrmImpostazioni from "./pages/platform/CrmImpostazioni";
import CrmBackup from "./pages/platform/CrmBackup";
import CrmProvvigioni from "./pages/platform/CrmProvvigioni";
import CrmTrattative from "./pages/platform/CrmTrattative";
import CrmMateriali from "./pages/platform/CrmMateriali";
import CrmPagamenti from "./pages/platform/CrmPagamenti";
import CrmDocumenti from "./pages/platform/CrmDocumenti";
import CrmOfferte from "./pages/platform/CrmOfferte";
import CrmProgetti from "./pages/platform/CrmProgetti";
import CrmReport from "./pages/platform/CrmReport";
import CrmExtra from "./pages/platform/CrmExtra";
import CrmVenditeDirette from "./pages/platform/CrmVenditeDirette";
import CrmModalita from "./pages/platform/CrmModalita";
import CrmDashboard from "./pages/platform/CrmDashboard";

import AgentRegister from "./pages/agent/AgentRegister";
import AgentVerifyEmail from "./pages/agent/AgentVerifyEmail";
import AgentLayout from "./pages/agent/AgentLayout";
import AgentDashboard from "./pages/agent/AgentDashboard";
import AgentProfile from "./pages/agent/AgentProfile";
import AgentAgreement from "./pages/agent/AgentAgreement";
import AgentContacts from "./pages/agent/AgentContacts";
import AgentDeals from "./pages/agent/AgentDeals";
import AgentMaterials from "./pages/agent/AgentMaterials";
import AgentPagamenti from "./pages/agent/AgentPagamenti";
import AgentDocuments from "./pages/agent/AgentDocuments";
import AgentCommissions from "./pages/agent/AgentCommissions";
import AgentOfferte from "./pages/agent/AgentOfferte";
import AgentProgetti from "./pages/agent/AgentProgetti";
import AgentProspetti from "./pages/agent/AgentProspetti";
import AgentExtra from "./pages/agent/AgentExtra";
import AgentModalita from "./pages/agent/AgentModalita";

/**
 * GlowBit Central — root routing (shell PLATFORM_ADMIN).
 * Auth condivisa (login, cambio password, recupero) riusabile dai futuri ruoli;
 * le sezioni operative restano riservate al PLATFORM_ADMIN.
 */
export default function App() {
  return (
    <BrandProvider>
      <AuthProvider>
        <IntroSplash />
        <Toaster position="top-right" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/platform/login" replace />} />
            <Route path="/platform/login" element={<PlatformLogin />} />
            <Route path="/platform/change-password" element={<PlatformChangePassword />} />
            <Route path="/platform/forgot-password" element={<PlatformForgotPassword />} />
            <Route path="/platform/reset-password" element={<PlatformResetPassword />} />
            <Route path="/platform/verify-email" element={<PlatformVerifyEmail />} />
            <Route path="/agent/register" element={<AgentRegister />} />
            <Route path="/platform/verify-agent-email" element={<AgentVerifyEmail />} />
            <Route path="/platform" element={<PlatformLayout />}>
              <Route index element={<Navigate to="/platform/crm/dashboard" replace />} />
              <Route path="salon-central" element={<SalonCentral />} />
              <Route path="crm/dashboard" element={<CrmDashboard />} />
              <Route path="crm/venditori" element={<CrmVenditori />} />
              <Route path="crm/contatti" element={<CrmContatti />} />
              <Route path="crm/trattative" element={<CrmTrattative />} />
              <Route path="crm/provvigioni" element={<CrmProvvigioni />} />
              <Route path="crm/pagamenti" element={<CrmPagamenti />} />
              <Route path="crm/materiali" element={<CrmMateriali />} />
              <Route path="crm/documenti" element={<CrmDocumenti />} />
              <Route path="crm/offerte" element={<CrmOfferte />} />
              <Route path="crm/progetti" element={<CrmProgetti />} />
              <Route path="crm/extra" element={<CrmExtra />} />
              <Route path="crm/vendite-dirette" element={<CrmVenditeDirette />} />
              <Route path="crm/modalita" element={<CrmModalita />} />
              <Route path="crm/report" element={<CrmReport />} />
              <Route path="crm/impostazioni" element={<CrmImpostazioni />} />
              <Route path="crm/backup" element={<CrmBackup />} />
              <Route path="audit" element={<PlatformAudit />} />
              <Route path="profile" element={<PlatformProfile />} />
              <Route path="identity" element={<PlatformIdentity />} />
            </Route>
            <Route path="/agent" element={<AgentLayout />}>
              <Route index element={<Navigate to="/agent/dashboard" replace />} />
              <Route path="dashboard" element={<AgentDashboard />} />
              <Route path="profile" element={<AgentProfile />} />
              <Route path="agreement" element={<AgentAgreement />} />
              <Route path="contacts" element={<AgentContacts />} />
              <Route path="deals" element={<AgentDeals />} />
              <Route path="materials" element={<AgentMaterials />} />
              <Route path="pagamenti" element={<AgentPagamenti />} />
              <Route path="documenti" element={<AgentDocuments />} />
              <Route path="commissions" element={<AgentCommissions />} />
              <Route path="offerte" element={<AgentOfferte />} />
              <Route path="progetti" element={<AgentProgetti />} />
              <Route path="extra" element={<AgentExtra />} />
              <Route path="modalita" element={<AgentModalita />} />
              <Route path="prospetti" element={<AgentProspetti />} />
            </Route>
            <Route path="*" element={<Navigate to="/platform/login" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </BrandProvider>
  );
}
